<template>
  <v-container fluid class="jobposting-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-jobposting`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Posting
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Details
          </v-tab>
          <v-tab-item
            :value="'tab-jobposting'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Posting</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePosting($event, 'jobtitle')"
                        v-bind:value="initvalue.jobtitle"
                        placeholder="Job Title"
                        persistent-hint
                        single-line hint="Enter the job title">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePosting($event, 'joblocation')"
                        v-bind:value="initvalue.joblocation"
                        placeholder="Menu Name"
                        persistent-hint
                        single-line hint="Enter the job location">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=jobtype
                        :value="initvalue.jobtype"
                        outlined
                        dense
                        v-on:change="onChangePosting($event, 'jobtype')"
                        placeholder="Job Type"
                        persistent-hint
                        single-line hint="Please choose the job type">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="departments.map(x => { return {text: x.departmentname, value: x._id} })"
                        v-on:change="onChangePosting($event, 'departmentid')"
                        v-bind:value="initvalue.departmentid"
                        v-bind:error="error == 'departmentid'"
                        outlined
                        dense
                        placeholder="Department"
                        persistent-hint
                        single-line hint="Please choose the department">
                      </v-select>
                      <v-menu
                        ref="menu_postingdate"
                        v-model="menu_postingdate"
                        :close-on-content-click="false"
                        :return-value.sync="edit_posting.postingdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="mb-4"
                            outlined
                            dense
                            v-model="edit_posting.postingdate"
                            label="Posting Date"
                            v-bind="attrs"
                            v-bind:value="edit_posting.postingdate"
                            v-on:change="
                              onChangeBill($event, 'postingdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Enter the posting date"
                            persistent-hint
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="edit_posting.postingdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_postingdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangePosting(edit_posting.postingdate,'postingdate');$refs.menu_postingdate.save(edit_posting.postingdate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_postingenddate"
                        v-model="menu_postingenddate"
                        :close-on-content-click="false"
                        :return-value.sync="edit_posting.postingenddate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="mb-4"
                            outlined
                            dense
                            v-model="edit_posting.postingenddate"
                            label="End Date"
                            v-bind="attrs"
                            v-bind:value="edit_posting.postingenddate"
                            v-on:change="
                              onChangeBill($event, 'postingenddate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Enter the end date"
                            persistent-hint
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="edit_posting.postingenddate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_postingenddate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangePosting(edit_posting.postingenddate,'postingenddate');$refs.menu_postingenddate.save(edit_posting.postingenddate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.postingstatus"
                        outlined
                        dense
                        v-on:change="onChangePosting($event, 'postingstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/jobposting/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editJobPostingRequest()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Details</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddDetail = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/jobposting/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="detailrank"
                        :headers="header_details"
                        :items="jobdetails"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDetail" width="500">
                            <v-card>
                              <v-card-title> Delete this Detail? </v-card-title>
                              <v-card-text>
                                {{ delete_detail.detailtype }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDetail = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePostingDetail(delete_detail)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.detailrank="{ item }">
                          <div style="vertical-align: top; height: 100%;">{{ item.detailrank }}</div>
                        </template>
                        <template v-slot:item.detailtype="{ item }">
                          <div style="vertical-align: top; height: 100%;">
                            <p class="two-line">{{ item.detailtype }}</p>
                            <p class="two-line">{{ item.detaillang }}</p>
                          </div>
                        </template>
                        <template v-slot:item.detailtext="{ item }">
                          <div v-html="item.detailtext"></div>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editPostingDetailDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePostingDetailDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddDetail"
      persistent
      width="1100px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="['Overview', 'Key Responsibilities', 'Education & Experience', 'Skills & Qualifications', 'Notes']"
                  v-model="add_detail.detailtype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  class="mb-4"
                  :items="['EN', 'CN', 'KH', 'MM', 'TH']"
                  v-model="add_detail.detaillang"
                  v-bind:error="errorindex == 1"
                  placeholder="Language"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <vue-editor v-model="add_detail.detailtext"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDetail=false; add_detail={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPostingDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditDetail"
      persistent
      width="1100px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDetail($event, 'detailrank')"
                  :value="edit_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="['Overview', 'Key Responsibilities', 'Education & Experience', 'Skills & Qualifications', 'Notes']"                  
                  v-on:change="onChangeDetail($event, 'detailtype')"
                  :value="edit_detail.detailtype"
                  v-bind:error="errorindex == 11"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  class="mb-4"
                  :items="['EN', 'CN', 'KH', 'MM', 'TH']"
                  v-on:change="onChangeDetail($event, 'detaillang')"
                  :value="edit_detail.detaillang"
                  v-bind:error="errorindex == 12"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <vue-editor
                  v-model="edit_detail.detailtext"
                  @text-change="onChangeDetail(edit_detail.detailtext, 'detailtext')"
                  :value="edit_detail.detailtext"
                ></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editPostingDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";

import { formatStdDate } from '@/mixins/date';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      header_details: [
        { text: "#", value: "detailrank", width: "10px" },
        { text: "Type & Language", value: "detailtype" , width: "20%" },
        { text: "Text", value: "detailtext" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      menu_postingdate: false,
      menu_postingenddate: false,
      initvalue: {},
      jobdetails: [],
      jobtype: ['Full Time', 'Part Time', 'Contract', 'Remote'],
      error: undefined,
      errorindex: undefined,
      edit_posting: {},
      change_posting: {},
      add_detail: {},
      edit_detail: {},
      change_detail: {},
      delete_detail: {},
      isDeleteDetail: false,
      isAddDetail: false,
      isEditDetail: false,
    }
  },
  computed: {
    ...mapState('JobPosting', ['isReceiving']),
    ...mapState('Department', ['departments']),
  },
  methods: {
    ...mapActions('JobPosting', 
    [ 
      'getJobPostingsRequest', 'deletePostingDetailRequest','insertPostingDetailRequest', 'updateJobPostingRequest','updatePostingDetailRequest',
    ]),
    async addPostingDetail() {
      this.isAddDetail = false;
      this.add_detail.postingid = this.initvalue._id;
      let result = await this.insertPostingDetailRequest(this.add_detail);
      this.jobdetails.push(result);
      this.add_detail = {};
    },
    deletePostingDetailDialog(item) {
      this.isDeleteDetail = true;
      this.delete_detail = { _id: item._id, detailtype: item.detailtype };
    },
    async deletePostingDetail(payload) {
      this.isDeleteDetail = false;
      let response = await this.deletePostingDetailRequest(payload);
      let index = this.jobdetails.findIndex((trans) => trans._id == response._id);
      this.jobdetails.splice(index, 1);
    },
    editPostingDetailDialog(item) {
      this.edit_detail = Object.assign({}, item);
      this.change_detail = {};
      this.isEditDetail = true;
    },
    async editJobPostingRequest() {
      this.change_posting._id = this.initvalue._id;
      await this.updateJobPostingRequest(this.change_posting);
      router.push('/jobposting/list');
    },
    async editPostingDetail() {
      this.isEditDetail = false;
      this.change_detail._id = this.edit_detail._id;
      let response = await this.updatePostingDetailRequest(this.change_detail);
      let index = this.jobdetails.findIndex((x) => x._id == response._id);
      this.jobdetails.splice(index, 1, response);
      this.edit_detail = {};
    }, 
    onChangePosting(value, field){
      this.change_posting[field] = value;
    },
    onChangeDetail(value, field){
      this.change_detail[field] = value;
    },   
  },

  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'JobPostingList' });
    this.edit_posting = Object.assign({}, this.initvalue);
    this.edit_posting.postingdate = formatStdDate(this.initvalue.postingdate);
    this.edit_posting.postingenddate = formatStdDate(this.initvalue.postingenddate);

    this.initvalue = this.$route.params;
    this.jobdetails = this.initvalue.details;

  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
